/**
 * Options for every scanner canvas whose pixels are READ BACK (getImageData /
 * toDataURL), which is all of them: blur and stability gates, the full-frame
 * RGBA read, cell and pill crops, the ROI encodes.
 *
 * Why (2026-09-30, Pixel 9a at 6 s a live frame): without this hint a fresh
 * canvas is GPU-backed and each readback is a GPU sync while Pokémon GO is
 * saturating the same GPU behind us. `willReadFrequently` keeps the canvas in
 * CPU memory, so a readback is a memcpy. 20-40 scanner canvases are created
 * per frame; one constant so no site forgets the hint.
 */
export const CANVAS_READBACK: CanvasRenderingContext2DSettings = { willReadFrequently: true };
